/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tags1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import Tags from './Tags/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function Tags1({
  children,
  viewPath = "/DesignSystem/TasksFilters/Tags",
  setOuterRef,
  left,
  top,
  setInnerRef
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let filtersTagsValueData = fromData.useDataFormat({ viewPath,
context: 'filters',
path: 'tags',
format: fromFormat.isEmptyList,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let filtersTagsValueData1 = fromData.useDataFormat({ viewPath,
context: 'filters',
path: 'tags',
format: fromFormat.isEmptyList,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 innerRef={setOuterRef}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={filtersTagsValueData}>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 data="filters.tags"
 format="/Data/format.js isEmptyList"
 text="Tags"
/>
</fromFlow.When>
<fromFlow.When is={!filtersTagsValueData1}>
<Tags
{...childProps}
  viewPath={`${viewPath}/Tags`}
 data="filters.tags"
 format="/Data/format.js isEmptyList"
/>
</fromFlow.When>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 fill2={dtColorsNeutral700}
 width={12}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}